const route = [
    {
        path: '/activity/2024newterm/index', //2023下期中检测
        component: function (resolve) {
            require(['VIEWS/activity/2024newterm/index.vue'], resolve);
        }
    },
]
export default route;
